import React, { useState, useEffect, useRef } from "react";
import { Translate } from "./LanguageChanger";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";

const AudioSettingsPage = ({ 
  onSpeedChange = (speed) => console.log("Speed changed to:", speed),
  currentSpeed = "1x",
  setShowSpeedControl = () => {},
}) => {
  const speedLabel = ["0.5x", "0.75x", "1x", "1.25x", "1.5x", "2x"];

  const [selectedSpeed, setSelectedSpeed] = useState(currentSpeed || "1x");
  const [focusedIndex, setFocusedIndex] = useState(speedLabel.indexOf(currentSpeed || "1x")); // Focus on current speed
  const speedRefs = useRef([]);

  useEffect(() => {
    speedRefs.current[focusedIndex]?.focus();
  }, []);
  useEffect(() => {
        sendTestMatomoEvent({
          eventCategory: "(Audio)",
          eventAction: "View",
          eventName: "SelectSpeedPopup",
        })
   
      },[])

  useEffect(() => {
    setSelectedSpeed(currentSpeed || "1x");
    const newIndex = speedLabel.indexOf(currentSpeed || "1x");
    setFocusedIndex(newIndex);
    speedRefs.current[newIndex]?.focus();
  }, [currentSpeed]);

  const handleMouseEnter = (index) => {
    setFocusedIndex(index);
    speedRefs.current[index]?.focus();
  };

  const handleKeyDownAudioSpeed = (e, index) => {
    if (e.key === "ArrowDown" && index < speedLabel.length - 1) {
      e.preventDefault();
      const next = index + 1;
      setFocusedIndex(next);
      speedRefs.current[next]?.focus();
    } else if (e.key === "ArrowUp" && index > 0) {
      e.preventDefault();
      const prev = index - 1;
      setFocusedIndex(prev);
      speedRefs.current[prev]?.focus();
    } else if (e.key === "Enter") {
      setSelectedSpeed(speedLabel[index]);
      onSpeedChange(speedLabel[index].replace("x", ""));
      
          }
  };

  return (
    <div style={styles.settingsMenu} className="settings-container">
      <div style={styles.tabs}>
        <Translate langKey={"speed"} />
      </div>

      <div style={styles.speedOptions}>
        {speedLabel.map((speed, index) => (
          <div
            key={speed}
            tabIndex={0}
            role="button"
            ref={(el) => (speedRefs.current[index] = el)}
            onMouseEnter={() => handleMouseEnter(index)}
            onKeyDown={(e) => handleKeyDownAudioSpeed(e, index)}
            onClick={() => {
              setSelectedSpeed(speed);
              onSpeedChange(speed.replace("x", ""));
              setShowSpeedControl(false);
            }}
            style={{
              ...styles.option,
              ...(focusedIndex === index ? styles.focusedOption : {}),
              ...(selectedSpeed === speed ? styles.selectedOption : {}),
            }}
          >
            {speed}
            {selectedSpeed === speed && (
              <span style={styles.checkmark}>✔</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  settingsMenu: {
    backgroundColor: "#000037",
    opacity: "1",
    color: "#FFFFFF",
    padding: "20px",
    width: "300px",
    borderRadius: "8px",
    fontFamily: "Anek Latin",
    position: "absolute",
    right: "0px",
    height: "95vh",
  },
  tabs: {
    display: "flex",
    justifyContent: "start",
    marginBottom: "20px",
    fontSize: "18px",
    fontWeight: "bold",
  },
  speedOptions: {
    display: "flex",
    flexDirection: "column",
  },
  option: {
    backgroundColor: "#273075",
    padding: "12px 20px",
    margin: "5px 0",
    borderRadius: "5px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "16px",
    outline: "none",
    transition: "background 0.2s, border 0.2s",
  },
  focusedOption: {
    backgroundColor: "#EC008C",
    
  },
 
  checkmark: {
    fontSize: "18px",
  },
};

export default AudioSettingsPage;
